import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const DELETE_BILLING_CODE_RESET = 'DELETE_BILLING_CODE_RESET';
export const DELETE_BILLING_CODE_LOADING = 'DELETE_BILLING_CODE_LOADING';
export const DELETE_BILLING_CODE_SUCCESS = 'DELETE_BILLING_CODE_SUCCESS';
export const DELETE_BILLING_CODE_REJECT = 'DELETE_BILLING_CODE_REJECT';

//* ACTIONS ------------------------------------------------
export const deleteBillingCodeReset = () => ({ type: DELETE_BILLING_CODE_RESET });
export const deleteBillingCodeLoading = () => ({ type: DELETE_BILLING_CODE_LOADING });
export const deleteBillingCodeSuccess = (payload) => ({ type: DELETE_BILLING_CODE_SUCCESS, payload });
export const deleteBillingCodeReject = (payload) => ({ type: DELETE_BILLING_CODE_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const deleteBillingCodeRequest = async (data = {}, getState) => {
    const options = await withToken({
        method: Methods.DELETE,
    }, getState);
    return request(`/BillingCode/web/DeleteBillingCode?BillingCodeId=${data.billingCodeId}`, options);
};
